/** Treat LinkedIn ghost/default CDN URLs as absent so UI shows the standard placeholder. */

const NON_CUSTOM_MARKERS = [
  "ghost",
  "silhouette",
  "defaultprofile",
  "gen-usr",
  "anonymous",
  "nophoto",
  "no_photo",
  "profile-displayphoto-shrink-null",
] as const;

export function isLinkedinNonCustomProfilePhotoUrl(url: string): boolean {
  const u = String(url || "")
    .trim()
    .toLowerCase();
  if (!u) return true;
  if (u.includes("undefined") || u.includes("/null") || u.endsWith("null")) return true;
  return NON_CUSTOM_MARKERS.some((m) => u.includes(m));
}

export function sanitizeLinkedinProfilePictureUrl(url: unknown): string {
  const s = String(url ?? "").trim();
  if (!s || isLinkedinNonCustomProfilePhotoUrl(s)) return "";
  return s;
}

/** Canonical placeholder for LinkedIn sender / account rows (no custom photo). */
export const DEFAULT_LINKEDIN_ACCOUNT_AVATAR_SRC = "/auth/chirag.svg";

export function linkedinAccountAvatarSrc(picture: unknown): string {
  return sanitizeLinkedinProfilePictureUrl(picture) || DEFAULT_LINKEDIN_ACCOUNT_AVATAR_SRC;
}
